import React from 'react';
import { number, shape, string } from 'prop-types';
import { Col, Row } from 'reactstrap';

import PrivacyContents from '../PrivacyContents';
import TextBox from '@components/TextBox/TextBox';
import Css from '../../Legal.scss';
import ImportImages from '@src/importImages';

const clouds = ImportImages('/legal/background-clouds.jpg');

const propTypes = {
  textboxContent: shape({
    content: string.isRequired,
    header: string.isRequired,
    id: number.isRequired
  })
};

const Mobile = ({ textboxContent }) => {
  const mobileStyles = {
    minHeight: `${window.innerHeight}px`,
    backgroundImage: `url(${clouds})`,
    backgroundSize: 'auto 100%',
    backgroundPosition: 'center center'
  };

  const textboxStyles = {
    backgroundColor: 'white',
    opacity: '0.7',
    fontSize: '16px',
    margin: '1.5rem',
    marginTop: '8rem',
    paddingBottom: '2rem'
  };

  return (
    <div id={'privacy'} className={'panel'} style={mobileStyles}>
      <Row className={'justify-content-center  align-items-center h-100'}>
        <Col xs={11}>
          <TextBox {...textboxContent} style={textboxStyles} isHeader={true} />
        </Col>
      </Row>

      <div className={Css['legal-mobile'] + 'w-100'}>
        <PrivacyContents />
      </div>
    </div>
  );
};

Mobile.propTypes = propTypes;

export default Mobile;



// WEBPACK FOOTER //
// ./src/components/Legal/Privacy/Mobile/Mobile.jsx